// src/components/DownloadButtons.js
import React from 'react';
import { saveAs } from 'file-saver';
export default function DownloadButtons({ asteroids, date }) {
    const downloadImage = () => {
        const canvas = document.querySelector('canvas');
        if (!canvas) return;
        canvas.toBlob(blob => saveAs(blob, `${date}.png`));
    };

    const downloadData = () => {
        const blob = new Blob([JSON.stringify(asteroids, null, 2)], { type: 'application/json' });
        saveAs(blob, `${date}_asteroids.json`);
    };

    return (
        <div style={{ margin: '1rem' }}>
            <button onClick={downloadImage}>Download Image</button>
            <button onClick={downloadData}>Download Data</button>
        </div>
    );
}